import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import SideDrawer from "../components/SideDrawer";

const RootLayout = () => {
  return (
    <div className="rootDiv">
      <SideDrawer />
      <Outlet />
      <Footer />
    </div>
  );
};

export default RootLayout;
